import api from '@/js/services/api';

export default {

    //get

    getArtistCategory() {
        return api().get(`/artist/categories/get`);
    },

    fetchArtistInfo() {
        return api().get(`/artist/get`);
    },


    //update


    updateGeneralArtistInfo(id, info) {
        return api().put(`/artist/${id}/update`, info);
    },

    updatePersonalArtistInfo(id, info) {
        return api().post(`/artist/${id}/personal-info/update`, info);
    },
    updatePhotosOrder(photosIds) {
        return api().put(`/artist/photos/order/update`, {photosIds});
    },

    updateArtistBankInfo(artist_id, info) {
        return api().post(`/artist/${artist_id}/bank-info/update`, info);
    },

    updateArtistGroupInfo(artist_id, members) {
        return api().post(`/artist/${artist_id}/group-members/update`, {members});
    },

    updateShowsArtistInfo(id, info) {
        return api().post(`/artist/${id}/shows/update`, info);
    },




    //upload

    uploadPhoto(userId, formData) {
        return api().post(`/files/user/${userId}/upload`, formData)
    },

    uploadPhotoInGallery(artist_id, files) {
        return api().post(`/artist/${artist_id}/photos/upload`, files);
    },

    uploadVideoInGallery(artist_id, files) {
        return api().post(`/artist/${artist_id}/videos/upload`, files);
    },

    uploadDocumentPhoto(artist_id, formData) {
        return api().post(`/artist/${artist_id}/personal-info/file/upload`, formData);
    },


    //delete

    deletePhotoFromGallery(photo_id) {
        return api().delete(`/artist/photo/${photo_id}/delete`);
    },

    deleteVideoFromGallery(video_id) {
        return api().delete(`/artist/video/${video_id}/delete`);
    },

    deletePhotoDocument(file_id) {
        return api().delete(`/artist/personal-info/file/${file_id}/delete`);
    },

    deleteGroupMember(member_id) {
        return api().delete(`/artist/group-members/${member_id}/delete`);
    }

}
